// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"18fa6421","126":"25316558","625":"8dba2b33","999":"14f053c1"}[chunkId] + ".chunk.js";
};